import React from "react";
import "./feedback.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Fade from "react-reveal/Fade";
import Image1 from "../../Image/partners/agra.jpeg";
import Image2 from "../../Image/partners/CIMMYT.jpeg";
import Image3 from "../../Image/partners/iar.png";
import Image4 from "../../Image/partners/idh.jpeg";
import Image5 from "../../Image/partners/iita.jpeg";
import Image6 from "../../Image/partners/IRRI.jpeg";
import Image7 from "../../Image/partners/NAERLS.jpeg";
import Image8 from "../../Image/partners/nasc.jpeg";
import Image9 from "../../Image/partners/propcom.jpeg";
import Image10 from "../../Image/partners/sasakawa.png";
import Image11 from "../../Image/partners/STARKE.png";

const Feedback = () => {
  const data = [
    {
      img: Image1,

      content: "",
      name: "Alliance for A Green Revolution in Africa",
      position: "",
    },

    {
      img: Image2,

      content: "",
      name: "International Maize and Wheat Improvement Center",
      position: "",
    },
    {
      img: Image3,

      content: "",
      name: "Institute for Agricultural Research",
      position: "",
    },
    {
      img: Image4,

      content: "",
      name: "IDH",
      position: "",
    },
    {
      img: Image5,

      content: "",
      name: "International Institute of Tropical Agriculture",
      position: "",
    },

    {
      img: Image6,

      content: "",
      name: "International Rice Research Institute",
      position: "",
    },
    {
      img: Image7,

      content: "",
      name: "National Agricultural Extension and Research Liaison Services",
      position: "",
    },

    {
      img: Image8,

      content: "",
      name: "National Agricultural Seeds Council",
      position: "",
    },

    {
      img: Image9,

      content: "",
      name: "Propcom+",
      position: "",
    },

    {
      img: Image10,

      content: "",
      name: "Sasakawa Africa Associatio",
      position: "",
    },

    {
      img: Image11,

      content: "",
      name: "Starke Ayres",
      position: "",
    },
  ];

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    adaptiveHeight: true,
    initialSlide: 0,
    autoplay: true,
    rows: 1,
    slidesPerRow: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="container feedback-slider" id="feedback">
      <div className="section_title">
        <h5>Partners</h5>
        <span className="line"></span>
      </div>

      <div className="feedbck-slide">
        <Slider {...settings}>
          {data.map((item, index) => (
            <Fade left>
              <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <div className="card content-slider" key={index}>
                  <img
                    src={item.img}
                    alt="slider image"
                    className="center-image"
                  />
                  <p>{item.content}</p>
                  <h4>{item.name}</h4>
                  <p>{item.position}</p>
                </div>
              </div>
            </Fade>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Feedback;
